import React from 'react'

import styled from "styled-components";

import { BiCheck } from 'react-icons/bi';


const List = ({ text }) => {
  return (
    <ListItem>
        <BiCheck className='icon' />
        {text}
    </ListItem>
  )
}

export default List

const ListItem = styled.div`
    display: grid;
    grid-template-columns: 1.5rem 1fr;
    grid-gap: 1rem;
    align-items: center;
    font-size: ${({ theme }) => theme.fontSizes.p};
    color: ${({ theme }) => theme.colors.primary};
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    text-transform: uppercase;
    
    .icon {
        font-size: 1.5rem;
        color: ${({ theme }) => theme.colors.secondary};
    }
    
    @media (max-width: 768px) {
        /* font-size: ${({ theme }) => theme.fontSizes.mobileP}; */
        align-items: flex-start;
        line-height: ${({ theme }) => theme.lineHeights.normal};
    }
`